/**
 *   Created by ATopcu in 2019
 */
import scope from "./scope";

export const ENABLE_AS_OF_DATE = `${scope}/ENABLE_AS_OF_DATE`;
export const setEnableAsOfDate = (enable) => ({
  type: ENABLE_AS_OF_DATE,
  payload: { enable },
});
export const DELETE_AS_OF_DATE = `${scope}/DELETE_AS_OF_DATE`;
export const deleteAsOfDate = () => ({
  type: DELETE_AS_OF_DATE,
});
